import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  loadingDots: {
    '& span': {
      display: 'inline-block',
      width: '4px',
      height: '4px',
      margin: '0 1px',
      backgroundColor: 'currentColor',
      borderRadius: '50%',
      animation: '$loadingDotsAnimation 1.5s infinite',
      '&:nth-child(1)': {
        animationDelay: '0s',
      },
      '&:nth-child(2)': {
        animationDelay: '0.3s',
      },
      '&:nth-child(3)': {
        animationDelay: '0.6s',
      },
    },
  },
  '@keyframes loadingDotsAnimation': {
    '0%, 20%': {
      opacity: 0.2,
    },
    '50%': {
      opacity: 1,
    },
    '80%, 100%': {
      opacity: 0.2,
    },
  },
}));
